module.exports = __webpack_public_path__ + "static/media/Illustration1-3.465bd949.jpg";